"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              active: Object.keys(Options)[0]
            };

          GState.bind(this, [
              "screen"
            ]);
        },
        onSelectTab: function(attribute, disabled) {
          if (disabled || (this.state.active == attribute)) {
            return;
          }

          this.state.active = attribute;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Learner/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Options = require("./options.json"),
    Options = module_Options.default || module_Options,
    Header_Learner_template = require("../../../components/Header-Learner.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "content-body py-4"
      },
    marko_attrs1 = {
        "class": "col"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        Header_Learner_tag({
            concern: "Settings",
            ranking: {}
          }, out, __component, "1");

        const smallScreen = ['xs', 'sm'].includes( state.screen.media )

        out.be("div", marko_attrs0, "2", component);

        Row_tag({
            class: "m-0",
            renderBody: function(out) {
              WSAdapt_tag({
                  ns: "col-md-3 col-12",
                  qs: "col-md-3 col-12",
                  hs: "col-md-4 col-12",
                  class: smallScreen ? "overflow-auto no-scrollbar px-0" : false,
                  renderBody: function(out) {
                    out.be("ul", {
                        "class": marko_classValue(smallScreen ? "list-inline mb-5" : "list-unstyled"),
                        style: "white-space:nowrap"
                      }, "5", component, null, 1);

                    marko_forIn(Options, function(attribute, { title, disabled }) {
                      var $keyValue$0 = "@" + attribute,
                          $keyScope$0 = "[" + ($keyValue$0 + "]");

                      out.be("li", {
                          "class": marko_classValue((("p-2 " + (state.active == attribute ? "theme-bg-primary white-text border-none" : "theme-bg")) + " ") + (disabled ? "disabled cursor-not-allowed" : "cursor-pointer"))
                        }, $keyValue$0, component, null, 1, {
                          onclick: __component.d("click", "onSelectTab", false, [
                              attribute,
                              disabled
                            ])
                        });

                      Locale_tag({
                          text: title,
                          class: "font-medium-3"
                        }, out, __component, "6" + $keyScope$0);

                      out.ee();
                    });

                    out.ee();
                  }
                }, out, __component, "4");

              out.be("div", marko_attrs1, "7", component);

              var $for$0 = 0;

              marko_forIn(Options, function(attribute, { main, title }) {
                var $keyScope$1 = "[" + (($for$0++) + "]");

                if (state.active == attribute) {
                  marko_dynamicTag(out, require("./sections/" + (main || title)), null, null, null, null, __component, "8" + $keyScope$1);
                }
              });

              out.ee();
            }
          }, out, __component, "3");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
